import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-department-breadcrumb-card',
  templateUrl: './helpbutton-department-breadcrumb-card.component.html',
  styleUrls: ['./helpbutton-department-breadcrumb-card.component.scss']
})
export class HelpbuttonDepartmentBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
